"use strict";
exports.__esModule = true;
var Promise = require("bluebird");
var guards_1 = require("../../guards");
var _1 = require("./");
var createPrepareTransfers_1 = require("./createPrepareTransfers");
exports.createSendTransfer = function (provider, attachFn) {
    var prepareTransfers = _1.createPrepareTransfers(provider);
    var sendTrytes = _1.createSendTrytes(provider, attachFn);
    return function sendTransfer(seed, depth, minWeightMagnitude, transfers, options, callback) {
        // If no options provided, switch arguments
        if (options && typeof options === 'function') {
            callback = options;
            options = createPrepareTransfers_1.getPrepareTransfersOptions({});
        }
        return Promise.resolve(guards_1.validate(guards_1.depthValidator(depth), guards_1.seedValidator(seed), guards_1.minWeightMagnitudeValidator(minWeightMagnitude), guards_1.arrayValidator(guards_1.transferValidator)(transfers)))
            .then(function () { return prepareTransfers(seed, transfers, options); })
            .then(function (trytes) { return sendTrytes(trytes, depth, minWeightMagnitude, options ? options.reference : undefined); })
            .asCallback(callback);
    };
};
//# sourceMappingURL=createSendTransfer.js.map